const commonReducer = (state = {}, action) => {
 
    switch (action.type) {
      case "SHOW_LOADER":
        return Object.assign({}, state, {
          loading: action.data,
        });
        case "SIDE_MENU":
        return Object.assign({}, state, {
          menuToggle: action.data,
        });
        case "EDIT_CANCEL":
          return Object.assign({}, state, {
            editCancel: action.data,
          });
        
        case "IS_LOADER":
          return Object.assign({}, state, {
            isLoading: action.data,
          });
        case "IS_LOADER1":
          return Object.assign({}, state, {
            isLoading1: action.data,
          });
          case "IS_LOADING":
          return Object.assign({}, state, {
            isLoading: action.data,
          });
        case "Add_User_IS_LOADER":
          return Object.assign({}, state, {
            addUserIsLoader: action.data,
          });
        case "IS_REGISTER_LOAD":
            return Object.assign({}, state, {
              isRegisterLoad: action.data,
            });
      default:
        return state;
    }
  };
  
  export default commonReducer;